class IFormFile {

    //Variables
    target;
    elLabelWrapper;
    elLabelSpan;

    //Methods
    constructor(target) {
        let thisObj = this;

        //Assign elements
        this.target = target;
        this.elLabelWrapper = target.parentElement;
        this.elLabelSpan = this.elLabelWrapper.getElementsByTagName('span')[0];


        //Add classes and adjust styles
        this.elLabelWrapper.classList.add('IFormFileWrapper');
        if (this.target.classList.contains('input-validation-error')) { //ASP.Net MVC - If a server-side validation error class was found on the <select>, apply it to the wrapper
            this.elLabelWrapper.classList.add('input-validation-error');
        }
        this.elLabelSpan.style.lineHeight = this.elLabelWrapper.offsetHeight.toString() + 'px'; //Set the line height of the label to the rendered height of the select to vertically center the content inside


        //Assign events
        $(thisObj.target).on('change', function () {

            //Get the selected filename
            let filename = '';
            try {

                //Attempt to get the filename from available variables
                if (this.files) { //Attempt to use the files array first (should work in most newer browsers)
                    filename = this.files[0].name;
                }
                else { //Fallback for IE9 - have to strip off full directory path
                    filename = this.value.split(/(\\|\/)/g).pop();
                }

                //Truncate the filename if necessary
                if (filename.length > 24)
                    filename = filename.substring(0, 24) + '...';
            }
            catch (e) { //Worst-case fallback - just state that the file was selected
                    filename = 'File Selected';
            }
            
            //Finally apply the formatted filename to the label
            thisObj.elLabelSpan.innerHTML = filename;

        });

        console.log('IFormFile initialized');
    }
}

//Instantiate on page load if matching HTML is found
let IFormFileList = [];
$(function () {
    let elementsByClass = document.getElementsByClassName("IFormFile");
    for (let i = 0; i < elementsByClass.length; i++) {
        IFormFileList.push(new IFormFile(elementsByClass.item(i)));
    };
});